/**
 * @const SETTINGS_EVENTS
 * @description collection of constant string id's related to settings events
 * @property {string} CLOSED=CLOSED string dispatched when settings are closed
 * @property {string} CHANGED=CHANGED string dispatched when settings are changed
 * @property {string} AUDIO_CHANGED=AUDIO_CHANGED string dispatched when settings audio is changed
 */
export const SETTINGS_EVENTS = {
  CLOSED: 'CLOSED',
  CHANGED: 'CHANGED',
  AUDIO_CHANGED: 'AUDIO_CHANGED',
};

/**
 * @const VIEWPORT_EVENTS
 * @description collection of constant string id's related to viewport events
 * @property {string} UPDATED='UPDATED' string dispatched when view port is updated
 */
export const VIEWPORT_EVENTS = {
  UPDATED: 'UPDATED',
};

/**
 * @const UI_EVENTS
 * @description collection of constant string id's related to ui events
 * @property {string} TAP=tap string dispatched as a tap event
 * @property {string} CLICK=tap string dispatched as a click event
 */
export const UI_EVENTS = {
  TAP: 'tap',
  CLICK: 'click',
};

/**
 * @const GAME_EVENTS
 * @description collection of constant string id's related to game events
 * @property {string} PAUSED=PAUSED dispatch on game paused
 * @property {string} RESUMED=RESUMED dispatched on game resumed
 */
export const GAME_EVENTS = {
  PAUSED: 'PAUSED',
  RESUMED: 'RESUMED',
};

/**
 * @const SCENE_EVENTS
 * @description collection of constant string id's related to scene controller events
 * @property {string} BRING_TO_TOP=BRING_TO_TOP dispatch on when new scene is brought to top of stack
 */
export const SCENE_EVENTS = {
  BRING_TO_TOP: 'BRING_TO_TOP',
};
